module.exports = __webpack_public_path__ + "static/media/login-bg.2eeb0447.jpg";